import React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { Loader, Toast } from "@sicredi/react";

/* Descomentar caso utilize a autenticação da plataforma. Remover se utilizar a do CAS */
/*import {
  createEmployeeOpenIdClient,
  createSalesForceEmployeeOpenIdClient,
} from "@sicredi/authentication";
import { APPLICATION } from "#/constants";*/

import "./global.scss";
import App from "#/containers/App";
import { startApiMockServer } from "#/api/server";
import { onResponse } from "#/utils/request";
import { Fallback, ErrorBoundary } from "#/components/ErrorBoundary";
import { version } from "./version";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { hotjar } from "react-hotjar";
import { HOTJAR } from "./constants";
import { googleTagManagerSetup } from "@sicredi/tag-manager-web";

const ROOT = document.getElementById("root")!;

function unmountRender(element: React.ReactElement) {
  unmountComponentAtNode(ROOT);
  render(element, ROOT);
}

unmountRender(<Loader show fullScreen />);

onResponse((response) => {
  function handleClose() {
    window.auth.actions.logout();
    window.location.reload();
  }

  if (response?.status === 401) {
    unmountRender(
      <Fallback title="Acesso negado" onClose={handleClose}>
        Você não possui autorização para acessar essa aplicação.
      </Fallback>
    );
  }
});

/* Descomentar caso utilize a autenticação da plataforma. Remover se utilizar a do CAS */
/*
const openIdClient =
  process.env.REACT_APP_JOB_TEMPLATE_TYPE !== "WEB_CRM"
    ? createEmployeeOpenIdClient
    : createSalesForceEmployeeOpenIdClient;

const authentication = openIdClient(
  APPLICATION.ENV === "mock" ? "dev" : APPLICATION.ENV,
  APPLICATION.ID,
  window.location.href,
  APPLICATION.EXTERNAL,
  {
    onIdpLogout: () =>
      toast.error("Sua sessão foi encerrada!", window.location.reload),
    onRefreshTokenError: () => toast.warn("Sua sessão encerrará em breve!"),
    onAuthenticationError: () =>
      // toast from from "@sicredi/react"
      toast.error("Problema na autenticação!", window.location.reload),
  }
);
*/

/* FAKE AUTH - Alterar quando adicionado autenticação plataforma/CAS */
const authentication = {
  async authenticate() {
    return {};
  },
  getJwtIdToken() {
    return { payload: "user" };
  },
  getAccessToken() {
    return "token";
  },
  logout() {
    return {};
  },
};

authentication
  .authenticate()
  .then((auth) => {
    if (
      process.env.NODE_ENV === "development" &&
      !!process.env.REACT_APP_MIRAGE &&
      process.env.REACT_APP_MIRAGE === "true"
    ) {
      startApiMockServer();
    }

    window.appVersion = version;

    window.auth = {
      ...auth,
      user: authentication.getJwtIdToken()!.payload,
      get token() {
        return authentication.getAccessToken();
      },
      actions: {
        logout: authentication.logout,
      },
    };

    unmountRender(
      <ErrorBoundary>
        <Toast />
        <App />
      </ErrorBoundary>
    );
  })
  .catch((err) => {
    if (err?.status && err?.status !== "URL_NOT_VERIFIED") {
      unmountRender(<Fallback />);
    }
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

if (HOTJAR.HJID) {
  hotjar.initialize(HOTJAR.HJID, HOTJAR.HJSV);
}

googleTagManagerSetup().initialize({
  config: {
    containerId: "GTM-NZDMMRM3",
    debug: false,
    userId: null,
  },
});
